export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
];

export const SUPPORTED_LANGUAGES = LANGUAGE_OPTIONS.map((l) => l.code);


export const HTML_LANG = {
  en: 'en',
  es: 'es',
  de: 'de',
  pl: 'pl',
  it: 'it',
  zh: 'zh-CN',
};

export const DATE_LOCALE = {
  en: 'en-US',
  es: 'es-ES',
  de: 'de-DE',
  pl: 'pl-PL',
  it: 'it-IT',
  zh: 'zh-CN',
};

export const TV_LOCALE = {
  en: 'en',
  es: 'es',
  de: 'de_DE',
  pl: 'pl',
  it: 'it',
  zh: 'zh_CN',
};

export function isSupportedLanguage(code) {
  return SUPPORTED_LANGUAGES.includes(code);
}

export function dateLocale(language) {
  return DATE_LOCALE[language] || DATE_LOCALE.en;
}

/** Merge a language dict on top of English so missing keys never go blank. */
export function pickLocale(map, language) {
  const base = map?.en || {};
  if (!isSupportedLanguage(language) || language === 'en') return { ...base };
  return { ...base, ...(map[language] || {}) };
}

export function detectLanguage() {
  try {
    const stored = localStorage.getItem('language');
    if (isSupportedLanguage(stored)) return stored;
  } catch (_) {
    /* ignore */
  }
  const nav = (typeof navigator !== 'undefined' && (navigator.languages?.[0] || navigator.language)) || 'en';
  const lower = String(nav).toLowerCase();
  const code = lower.startsWith('zh') ? 'zh' : lower.slice(0, 2);
  return isSupportedLanguage(code) ? code : 'en';
}

export function applyDocumentLang(language) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = HTML_LANG[language] || 'en';
}
